import { checkPermissions } from "@utils";

export const getCRUDPermissions = (app_name: string, model_name: string) => {
  return {
    canView: checkPermissions(`${app_name}.view_${model_name}`),
    canAdd: checkPermissions(`${app_name}.add_${model_name}`),
    canEdit: checkPermissions(`${app_name}.change_${model_name}`),
    canDelete: checkPermissions(`${app_name}.delete_${model_name}`),
  };
};
